// https://cmsdev.cruisecode.com/BookingPlatform/GetAgentUsers?CUID=72aca93d-62a8-48e8-abf5-9814dc7604ae&_=1694582877395

export const GetAgentUsers = [
    {
        PartnerId: 35,
        Type: 0,
        PartnerName: 'Alaska \u0026 Yukon Tours',
        UniqueName: 'Alaska \u0026 Yukon Tours',
        ContactPersonFirstName: 'Nate',
        ContactPersonLastName: 'Vallier',
        PhoneNumber: '(907) 531-9140',
        CompanyUniqueId: null,
        Email: 'nate@alaskayukontours.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: null,
        AllowInvoice: true,
        Website: 'www.alaskaexcursions.net',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 28,
        Type: 0,
        PartnerName: 'Alaska Shore Tours',
        UniqueName: 'Alaska Shore Tours',
        ContactPersonFirstName: 'Drew',
        ContactPersonLastName: 'Fortner',
        PhoneNumber: '(907) 983-4444',
        CompanyUniqueId: null,
        Email: 'info@alaskashoretours.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'https://alaskashoretours.com/',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 18,
        Type: 0,
        PartnerName: 'Alaska X',
        UniqueName: 'Alaska X',
        ContactPersonFirstName: 'Robert',
        ContactPersonLastName: 'Murphy',
        PhoneNumber: '(907) 957-0746',
        CompanyUniqueId: null,
        Email: 'it@alaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'www.alaskax.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 38,
        Type: 0,
        PartnerName: 'asf',
        UniqueName: 'asf 5765',
        ContactPersonFirstName: 'Robert',
        ContactPersonLastName: 'Murphy',
        PhoneNumber: '19079570746',
        CompanyUniqueId: null,
        Email: 'robert@alllllaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.wwwww.www',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 22,
        Type: 0,
        PartnerName: 'Boring Company',
        UniqueName: 'Intersting Companyasdfsdf',
        ContactPersonFirstName: 'Will',
        ContactPersonLastName: 'X',
        PhoneNumber: '12345467890',
        CompanyUniqueId: null,
        Email: 'william@cruisecode.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.thing.io',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 68,
        Type: 0,
        PartnerName: 'Compnay 12',
        UniqueName: 'Uniqueness 23',
        ContactPersonFirstName: 'Jacob',
        ContactPersonLastName: 'Youakim',
        PhoneNumber: '9528470308',
        CompanyUniqueId: null,
        Email: 'jacobyouakim@hotmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: false,
        Website: 'www.opopop.coi',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 31,
        Type: 0,
        PartnerName: 'Frontier Excursions',
        UniqueName: 'Frontier Excursions',
        ContactPersonFirstName: 'Cris',
        ContactPersonLastName: 'Siegel',
        PhoneNumber: '(907) 713-7527',
        CompanyUniqueId: null,
        Email: 'criskatie@gmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'www.frontierexcursions.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 23,
        Type: 0,
        PartnerName: 'Holland America',
        UniqueName: 'HAP - Skagway',
        ContactPersonFirstName: 'Westmark',
        ContactPersonLastName: 'Skagway',
        PhoneNumber: '907-983-6088',
        CompanyUniqueId: null,
        Email: 'sales@hagroup.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'www.westmark.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 19,
        Type: 0,
        PartnerName: 'Holland America Line',
        UniqueName: 'Holland America Line',
        ContactPersonFirstName: 'Robert',
        ContactPersonLastName: 'Murphy',
        PhoneNumber: '(907) 957-0746',
        CompanyUniqueId: null,
        Email: 'hal@alaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.HollandAmerica.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: true,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 56,
        Type: 0,
        PartnerName: 'Interesting Company',
        UniqueName: 'Intersting Company123',
        ContactPersonFirstName: 'Jacob',
        ContactPersonLastName: 'Yi',
        PhoneNumber: '(234) 546-7890',
        CompanyUniqueId: null,
        Email: 'jacobyi@alaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: true,
        Website: 'www.thing.io',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 58,
        Type: 0,
        PartnerName: 'Intersting Company',
        UniqueName: 'Intersting Company',
        ContactPersonFirstName: 'Jacob',
        ContactPersonLastName: 'Youakim',
        PhoneNumber: '9528470308',
        CompanyUniqueId: null,
        Email: 'jacobyouakim@gmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.thing.io',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 57,
        Type: 0,
        PartnerName: 'Intersting Company',
        UniqueName: 'Intersting Companyasdfsdf',
        ContactPersonFirstName: 'Will',
        ContactPersonLastName: 'X',
        PhoneNumber: '+18005551212',
        CompanyUniqueId: null,
        Email: 'william@cruisecode.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.thing.io',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 50,
        Type: 0,
        PartnerName: 'Intersting Company',
        UniqueName: 'REALLY Intersting Company',
        ContactPersonFirstName: 'Robert',
        ContactPersonLastName: 'Murphy',
        PhoneNumber: '(907)-957-0746',
        CompanyUniqueId: null,
        Email: 'robertagent@alaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'www.thing.io',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 39,
        Type: 0,
        PartnerName: 'John Agency 345',
        UniqueName: 'John Agency 345',
        ContactPersonFirstName: 'Alkesh',
        ContactPersonLastName: 'Patel',
        PhoneNumber: '(224) 200-9706',
        CompanyUniqueId: null,
        Email: 'Alkesh@AlaskaX.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 0,
        AllowInvoice: false,
        Website: 'https://www.alaskax.com/',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 30,
        Type: 0,
        PartnerName: 'Juneau Tours LLC',
        UniqueName: 'Juneau Tours LLC',
        ContactPersonFirstName: 'Serene ',
        ContactPersonLastName: 'Hutchinson',
        PhoneNumber: '907-723-9209',
        CompanyUniqueId: null,
        Email: 'info@juneautours.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'https://www.juneautours.com/',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 36,
        Type: 0,
        PartnerName: 'Keli\u0027s Concierge',
        UniqueName: 'Keli\u0027s Concierge',
        ContactPersonFirstName: 'Keli',
        ContactPersonLastName: 'Donnelly',
        PhoneNumber: '7274186975',
        CompanyUniqueId: null,
        Email: 'keli@kelisconcierge.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'www.kelisconcierge.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 33,
        Type: 0,
        PartnerName: 'Klondike Tours',
        UniqueName: 'Klondike Tours',
        ContactPersonFirstName: 'Greg ',
        ContactPersonLastName: 'Clem',
        PhoneNumber: '9079832075',
        CompanyUniqueId: null,
        Email: 'klondiketours@gmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: null,
        AllowInvoice: true,
        Website: 'www.klondiketours.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 37,
        Type: 0,
        PartnerName: 'Liquid Alaska Tours',
        UniqueName: 'Liquid Alaska Tours OTC',
        ContactPersonFirstName: 'Jeff ',
        ContactPersonLastName: 'Fanning',
        PhoneNumber: '800-892-5504',
        CompanyUniqueId: null,
        Email: 'info@liquidalaskatours.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'https://liquidalaskatours.com/',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 25,
        Type: 0,
        PartnerName: 'M \u0026 M Tours',
        UniqueName: 'M \u0026 M Tours',
        ContactPersonFirstName: 'Mark',
        ContactPersonLastName: 'Jennings',
        PhoneNumber: '(907) 983-3900',
        CompanyUniqueId: null,
        Email: 'toursskagway@gmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 25,
        AllowInvoice: true,
        Website: 'www.skagwayalaskatours.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 32,
        Type: 0,
        PartnerName: 'M and M Tours of Juneau',
        UniqueName: 'M\u0026M (Juneau)',
        ContactPersonFirstName: 'Admin',
        ContactPersonLastName: 'Admin',
        PhoneNumber: '(907) 209-1975',
        CompanyUniqueId: null,
        Email: 'reservations.mmtoursofjuneau@1gmail.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'mmtoursofjuneau.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 34,
        Type: 0,
        PartnerName: 'Shore Trips',
        UniqueName: 'Shore Trips',
        ContactPersonFirstName: 'Sam',
        ContactPersonLastName: 'Karp',
        PhoneNumber: '(414) 964-2100',
        CompanyUniqueId: null,
        Email: 'sam.karp@cityexperiences.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'shoretrips.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 1,
        Type: 0,
        PartnerName: 'Tauck',
        UniqueName: 'Tauck',
        ContactPersonFirstName: 'TBD',
        ContactPersonLastName: '',
        PhoneNumber: '9079834444',
        CompanyUniqueId: null,
        Email: 'TBD@asdhfjashdkfjal.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: null,
        AllowInvoice: null,
        Website: null,
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 29,
        Type: 0,
        PartnerName: 'Venture Ashore',
        UniqueName: 'Venture Ashore',
        ContactPersonFirstName: 'Josh',
        ContactPersonLastName: 'Dickinson',
        PhoneNumber: '(844) 491-4164',
        CompanyUniqueId: null,
        Email: 'operations@ventureashore.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: true,
        Website: 'https://www.ventureashore.com/',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
    {
        PartnerId: 21,
        Type: 0,
        PartnerName: 'Viator',
        UniqueName: 'Viator',
        ContactPersonFirstName: 'Viator',
        ContactPersonLastName: 'Booking',
        PhoneNumber: '(907) 983-4444',
        CompanyUniqueId: null,
        Email: 'viator@alaskax.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: 20,
        AllowInvoice: false,
        Website: 'www.Viator.com',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: null,
        ShipCompanyId: null,
        IsTaxable: null,
    },
];
